<div class="titleBox">
    <span class="title"> Feedback</span>
    <span class="desc">Help us to enhance your experience in future. </span>
</div>
<div class="contentBox" fxLayout="column">
    <!-- *ngIf="feedbackResponse?.length==[]" -->

    <div class="feedbackForm">
        <div *ngFor=" let feedback of feedback_items; index  as i">
            <span>{{feedback.question}}</span>
            <div class="rating">
                <mat-radio-group>
                    <mat-radio-button [value]="feedback_items[i].rating == 10" (click)="set_rating(10, i)"><img
                            src="/assets/images/rating/very_dissatisfied.png" alt=""
                            matTooltip="Very Dissatisfied"></mat-radio-button>
                    <mat-radio-button [value]="feedback_items[i].rating == 20" (click)="set_rating(20, i)"><img
                            src="/assets/images/rating/dissatisfied.png" matTooltip="Dissatisfied"
                            alt=""></mat-radio-button>
                    <mat-radio-button [value]="feedback_items[i].rating == 30" (click)="set_rating(30, i)"><img
                            src="/assets/images/rating/ok.png" matTooltip="Ok" alt=""></mat-radio-button>
                    <mat-radio-button [value]="feedback_items[i].rating == 40" (click)="set_rating(40, i)"><img
                            src="/assets/images/rating/satisfied.png" matTooltip="Satisfied" alt=""></mat-radio-button>
                    <mat-radio-button [value]="feedback_items[i].rating == 50" (click)="set_rating(50, i)"><img
                            matTooltip="Very Satisfied" src="/assets/images/rating/very_satisfied.png"
                            alt=""></mat-radio-button>
                </mat-radio-group>
            </div>
            <ng-container *ngIf="!(feedback_items[i].rating == 40 || feedback_items[i].rating == 50) ">
                <div class="comment" [class.active]="i==current_feedback_index || feedback_items[i].remarks!=''">
                    <app-text-field [isEditable]="true" [isMultiline]="true" [placeholder]="placeholder"
                        [(ngModel)]="feedback_items[i].remarks" fxFlex="100"></app-text-field>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="btnb">
        <!-- <button mat-raised-button class="Cancel sleekBtn" (click)="skipFeedback()">Skip</button> -->
        <button mat-raised-button class="Save fbSubmit sleekBtn " (click)="postfeedbackSubmit()"> Submit</button>
    </div>
</div>